import { Typography } from '../../molecules/Typography';
import { Modal } from '../../templates/Modal';
import { EventDetails, iEventDetails } from '../EventDetails';

interface iEventDetailsModalProps {
  event?: iEventDetails;
  footer?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

function EventDetailsModal({
  event,
  footer,
  isOpen,
  onClose,
}: iEventDetailsModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className='m-4 pt-0'
      title='Detalhes do evento'
      headerType='LiveEventDetail'
    >
      {event ? (
        <EventDetails event={event} footer={footer} />
      ) : (
        <div className='flex h-full items-center justify-center'>
          <Typography variant='italic' className='mt-7'>
            Selecione um evento da agenda para ver os detalhes
          </Typography>
        </div>
      )}
    </Modal>
  );
}
export { EventDetailsModal };
